import React from "react";

import Modal from "@atoms/Modal/Modal";

import * as S from "./CancelPublishArticleModal.style";

interface Props {
  closeModal: () => void;
  onConfirm: (e: React.MouseEvent) => void;
  isOpen: boolean;
}

const CancelPublishArticleModal = ({
  closeModal,
  onConfirm,
  isOpen,
}: Props) => {
  return (
    <>
      {isOpen && (
        <Modal closeModal={closeModal}>
          <S.PressListEntryModalWrapper>
            <S.ModalTitle>Unpublish Article Confirmation</S.ModalTitle>

            <S.ModalText>
              This article is currently published. Changing the status to
              &apos;Unsuitable&apos; will unpublish it and remove it from the
              website. Are you sure you want to proceed with this change?
            </S.ModalText>

            <S.ModalButtonWrapper>
              <S.CancelButton type="button" onClick={closeModal}>
                Cancel
              </S.CancelButton>
              <S.RefreshButton type="button" onClick={onConfirm}>
                Confirm
              </S.RefreshButton>
            </S.ModalButtonWrapper>
          </S.PressListEntryModalWrapper>
        </Modal>
      )}
    </>
  );
};

export default CancelPublishArticleModal;
